import { Button, MailIcon } from '@viapeople/components'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { type Column, GenericTable } from '../../../../components/GenericTable'
import { trpc } from '../../../../utils/trpc'
import type { CycleEmailHistoryListing, CycleEmailHistorySearchInput } from '../types'

export function CycleEmailsHistoryTab() {
	const { organizationId, cycleId } = useParams<{ organizationId: string; cycleId: string }>()
	const navigate = useNavigate()

	const columns: Column<CycleEmailHistoryListing>[] = [
		{
			field: 'name',
			label: 'Email Name',
		},
		{
			field: 'subject',
			label: 'Subject',
		},
		{
			field: 'sentAt',
			label: 'Sent time',
			render: (history) => history.sentAt?.toLocaleString() ?? '-',
		},
		{
			field: 'id',
			label: '',
			render: (history) => (
				<Button
					variant='secondary'
					onClick={() => {
						navigate(`/organizations/${organizationId}/cycles/${cycleId}/emails/email-history/${history.id}`)
					}}>
					View Log
				</Button>
			),
		},
	]

	return (
		<div>
			<GenericTable<CycleEmailHistoryListing, CycleEmailHistorySearchInput>
				queryOptionsGenerator={(options) => ({
					...trpc.admin.cycles.emails.history.search.queryOptions({
						...options,
						cycleId: cycleId || '',
					}),
					enabled: !!cycleId,
				})}
				isInternal
				columns={columns}
				showPagination
				emptyState={{
					title: 'No emails sent yet',
					description: 'No emails have been sent for this cycle yet',
					icon: MailIcon,
				}}
			/>

			<Outlet />
		</div>
	)
}
